'use client';

import { useInfiniteQuery } from '@tanstack/react-query';
import Axios from '@/lib/axiosConfig';
import type { Education } from '@/types/education';
type PublicEducationPage = {
  responseObject: { rows: Education[]; count: number };
};

export const usePublicEducationLists = (
  // Server-rendered first page. Seeding it keeps the SSR markup and the first
  // client render identical, so crawlers and users see the same list.
  initialData?: PublicEducationPage | null
) => {
  const infiniteQuery = useInfiniteQuery({
    queryKey: ['educations', 'public'],
    queryFn: () => {
        return Axios.get('/educations/public').then(res => {
          return {
            responseObject: {
              rows: res.data.responseObject || [],
              count: res.data.responseObject?.length || 0,
            },
          };
        });
    },
    initialPageParam: 0,
    getNextPageParam: () => undefined,
    ...(initialData
      ? { initialData: { pages: [initialData], pageParams: [0] } }
      : {}),
  });
  return infiniteQuery;
};

